export * from './errorCodes';

export const isUs = true;
export const defaultSiteLanguage = 'en-us';
export const phoneNumberPrefix = '+1';
export const patientSupportPhoneNumberUs = '+1 888 454 5580';

export const isRouterDevToolsEnabled =
	import.meta.env.VITE_ENABLE_TANSTACK_ROUTER_DEV_TOOLS === 'true';
